import { Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext'; // Importa il provider del contesto di autenticazione

import Home from './components/home/Home';
import Nav from './components/home/Nav';
import Login from './components/home/Login';
import LoginDipendenti from './components/home/LoginDipendenti';
import Moduli from './components/home/Moduli';
import Blog from './components/home/Blog';
import Privacy from './components/home/Privacy';
import Scadenze from './components/home/Scadenze';
import Formazione from './components/home/Formazione';
import FileManager from "./components/operatore/FileManager";
import Footer from "./components/home/Footer";

import SuccessPage from './components/home/SuccessPage';
import WhatsappButton from './components/home/WhatsappButton';
import PagamentoOk from './components/PagamentoOk';
import PagamentoKo from './components/PagamentoKo';


import Cli from './components/cliente/Cli';

import AreaDipendenti from './components/cliente/AreaDipendenti';
import AreaDipTimbrature from './components/cliente/AreaDipTimbrature';

import CliContratt from './components/cliente/CliContratt';
import CliAmm from './components/cliente/CliAmm';
import CliPaghe from './components/cliente/CliPaghe';
import CliEnti from './components/cliente/CliEnti';
import PrevisioneCosti from './components/cliente/PrevisioneCosti';
import CliDomande from './components/cliente/CliDomande';
import PrenotaSala from './components/cliente/PrenotaSala';
import PrenotaCBA from './components/cliente/PrenotaCba';
import CliGuida from './components/cliente/CliGuida';
import CliNews from './components/cliente/CliNews';

import ContrAssunzione from './components/cliente/ContrAssunzione';
import ContrCessazione from './components/cliente/ContrCessazione';
import ContrProroghe from './components/cliente/ContrProroghe';
import ContrTrasform from './components/cliente/ContrTrasform';
import ContrIntermittenti from './components/cliente/ContrIntermittenti';
import ContrInfortunio from './components/cliente/ContrInfortunio';
import ContrContestazioni from './components/cliente/ContrContestazioni';
import ContrDistacco from './components/cliente/ContrDistacco';
import ContrDistaccoEst from './components/cliente/ContrDistaccoEst';
import ContrPraticheGeneriche from './components/cliente/ContrPraticheGeneriche';

import CliAmmAzienda from './components/cliente/CliAmmAzienda'
import CliAmmAvvisiParcella from './components/cliente/CliAmmAvvisiParcella'
import CliAmmFatture from './components/cliente/CliAmmFatture';
import CliAmmCollabora from './components/cliente/CliAmmCollabora';
import CliAmmDipendenti from './components/cliente/CliAmmDipendenti';

import CliEntiEdilConnect from './components/cliente/CliEntiEdilConnect';
import CliEntiNoteRett from './components/cliente/CliEntiNoteRett';

import PagPresenze from './components/cliente/PagPresenze';
import PagBustePaga from './components/cliente/PagBustePaga';
import PagMalattia from './components/cliente/PagMalattia';
import PagCassaInteg from './components/cliente/PagCassaInteg';


import Op from './components/operatore/Op';

import OpContrattualistica from './components/operatore/OpContrattualistica';
import OpAmm from './components/operatore/OpAmm';
import OpPaghe from './components/operatore/OpPaghe';
import OpEnti from './components/operatore/OpEnti';
import OpDomande from './components/operatore/OpDomande';
import OpPrenotaSala from './components/operatore/OpPrenotaSala';
import OpRichiesteCba from './components/operatore/OpRichiesteCba';

import OpPratiche from './components/operatore/OpPratiche';

import DetAssunzione from "./components/operatore/ticketdetail/DetAssunzione";
import DetCessazione from "./components/operatore/ticketdetail/DetCessazione";
import DetProroghe from "./components/operatore/ticketdetail/DetProroghe";
import DetTrasformazione from "./components/operatore/ticketdetail/DetTrasformazione";
import DetIntermittenti from "./components/operatore/ticketdetail/DetIntermittenti";
import DetMalattia from "./components/operatore/ticketdetail/DetMalattia";
import DetCassaIntegrazione from "./components/operatore/ticketdetail/DetCassaIntegrazione";
import DetInfortunio from "./components/operatore/ticketdetail/DetInfortunio";
import DetContestazioni from "./components/operatore/ticketdetail/DetContestazione";
import DetDistacco from "./components/operatore/ticketdetail/DetDistacco";
import DetDistaccoEst from "./components/operatore/ticketdetail/DetDistaccoEst";
import DetPraticheGeneriche from "./components/operatore/ticketdetail/DetPraticheGeneriche";
import DetAnnullamenti from "./components/operatore/ticketdetail/DetAnnullamento";

import OpAmmListaAziende from "./components/operatore/OpAmmListaAziende";
import OpAmmDipendenti from "./components/operatore/OpAmmDipendenti";
import OpAmmAvvisiParcella from "./components/operatore/OpAmmAvvisiParcella";
import OpAmmAvvisiParcellaDet from './components/operatore/OpAmmAvvisiParcellaDet';
import OpAmmFatture from "./components/operatore/OpAmmFatture";
import OpAmmPraticheArchiviate from "./components/operatore/OpAmmPraticheArchiviate";
import OpAmmCollaborazioni from "./components/operatore/OpAmmCollaborazioni";

import OpPagPresenze from './components/operatore/OpPagPrezenze';
import OpPagBustePaghe from './components/operatore/OpPagBustePaghe';
import OpPagheFatte from './components/operatore/OpPagheFatte';
import OpPagArchivio from './components/operatore/OpPagArchivio';

import OpEntiArc from './components/operatore/OpEntiArc';
import OpEntiEdilConnect from './components/operatore/OpEntiEdilConnect';
import OpEntiEdilConnectDet from './components/operatore/OpEntiEdilConnectDet';
import OpEntiNoteRett from './components/operatore/OpEntiNoteRett';

import OpPannelloControllo from './components/operatore/OpPannelloControllo';
import OpOperazioni from './components/operatore/OpOperazioni';
import OpAmmFatturato from './components/operatore/OpAmmFatturato';
import OpSituazioneGenerale from './components/operatore/OpSituazioneGenerale';
import OpContabilita from './components/operatore/OpContabilita';
import OpLogs from './components/operatore/OpLogs';
import FeedForm from './components/operatore/FeedForm';
import OpNotifiche from './components/operatore/OpNotifiche';
import OpNews from './components/operatore/OpNews';

import DettaglioAzienda from "./components/operatore/DettaglioAzienda";

import WorkinProgress from "./components/WorkinProgress";

import Chat from './components/Chat';
import Memo from "./components/Memo";
import Ai from './components/Ai';

const WhatsappButtonWrapper = () => {
  const location = useLocation();
  return location.pathname === "/" ? <WhatsappButton /> : null;
};
const ChatButtonWrapper = () => {
  const [searchParams] = useSearchParams();
  const startsOpen = searchParams.get("chat");
  return <Chat startsOpen={startsOpen} />;
}

const App = () => {

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Nav />

        <Box component="main" sx={{ flexGrow: 1, pb: 0, display: 'flex', flexDirection: 'column' }}>
          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logindipendenti" element={<LoginDipendenti />} />
            <Route path="/moduli" element={<AuthProvider><Moduli /></AuthProvider>} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/formazione" element={<Formazione />} />
            <Route path="/filemanager" element={<FileManager />} />

            <Route path="/scadenze" element={<Scadenze />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/pagamento/ok" element={<PagamentoOk />} />
            <Route path="/pagamento/ko" element={<PagamentoKo />} />


            <Route path="/cli" element={<Cli />} />

            <Route path="/dip" element={<AreaDipendenti />} />

            <Route path="/cli/contrattualistica" element={<CliContratt />} />
            <Route path="/cli/amministrazione" element={<CliAmm />} />
            <Route path="/cli/paghe" element={<CliPaghe />} />
            <Route path="/cli/enti" element={<CliEnti />} />
            <Route path="/cli/previsionecosti" element={<WorkinProgress />} />
            <Route path="/cli/previsionecostitest" element={<PrevisioneCosti />} />
            <Route path="/cli/domande" element={<CliDomande />} />
            <Route path="/cli/prenotasala" element={<WorkinProgress />} />
            <Route path="/cli/prenotacba" element={<PrenotaCBA />} />
            <Route path="/cli/guida" element={<CliGuida />} />
            <Route path="/cli/news" element={<CliNews />} />
            <Route path="/cli/feedform" element={<FeedForm />} />

            <Route path="/cli/contrattualistica/assunzione" element={<ContrAssunzione />} />
            <Route path="/cli/contrattualistica/cessazione" element={<ContrCessazione />} />
            <Route path="/cli/contrattualistica/proroga" element={<ContrProroghe />} />
            <Route path="/cli/contrattualistica/trasformazione" element={<ContrTrasform />} />
            <Route path="/cli/contrattualistica/chiamataintermittente" element={<ContrIntermittenti />} />
            <Route path="/cli/contrattualistica/infortunio" element={<ContrInfortunio />} />
            <Route path="/cli/contrattualistica/contestazione" element={<ContrContestazioni />} />
            <Route path="/cli/contrattualistica/distacco" element={<ContrDistacco />} />
            <Route path="/cli/contrattualistica/distaccoestero" element={<ContrDistaccoEst />} />
            <Route path="/cli/contrattualistica/vardatori" element={<WorkinProgress />} />
            <Route path="/cli/contrattualistica/praticagenerica" element={<ContrPraticheGeneriche />} />

            <Route path="/cli/amministrazione/azienda" element={<WorkinProgress />} />
            <Route path="/cli/amministrazione/avvisiparcella" element={<CliAmmAvvisiParcella />} />
            <Route path="/cli/amministrazione/fatture" element={<CliAmmFatture />} />
            <Route path="/cli/amministrazione/collabora" element={<CliAmmCollabora />} />

            <Route path="/cli/enti/edilconnect" element={<CliEntiEdilConnect />} />
            <Route path="/cli/enti/noterett" element={<CliEntiNoteRett />} />

            <Route path="/cli/presenze" element={<PagPresenze />} />
            <Route path="/cli/bustepaga" element={<PagBustePaga />} />
            <Route path="/cli/malattia" element={<PagMalattia />} />
            <Route path="/cli/cassaintegrazione" element={<PagCassaInteg />} />
            <Route path="/cli/dipendenti" element={<CliAmmDipendenti />} />
            <Route path="/cli/timbrature" element={<AreaDipTimbrature />} />


            <Route path="/op" element={<Op />} />

            <Route path="/op/contrattualistica" element={<OpContrattualistica />} />
            <Route path="/op/amministrazione" element={<OpAmm />} />
            <Route path="/op/paghe" element={<OpPaghe />} />
            <Route path="/op/enti" element={<OpEnti />} />
            <Route path="/op/costi" element={<PrevisioneCosti isOp={true} />} />
            <Route path="/op/domande" element={<OpDomande />} />
            <Route path="/op/prenotasala" element={<OpPrenotaSala />} />
            <Route path="/op/richiestecba" element={<OpRichiesteCba />} />
            <Route path="/op/guida" element={<CliGuida isOp={true} />} />

            <Route path="/op/contrattualistica/assunzione" element={<ContrAssunzione op={true} />} />
            <Route path="/op/contrattualistica/cessazione" element={<ContrCessazione op={true} />} />
            <Route path="/op/contrattualistica/proroga" element={<ContrProroghe op={true} />} />
            <Route path="/op/contrattualistica/trasformazione" element={<ContrTrasform op={true} />} />
            <Route path="/op/contrattualistica/chiamataintermittente" element={<ContrIntermittenti op={true} />} />
            <Route path="/op/contrattualistica/infortunio" element={<ContrInfortunio op={true} />} />
            <Route path="/op/contrattualistica/contestazione" element={<ContrContestazioni op={true} />} />
            <Route path="/op/contrattualistica/distacco" element={<ContrDistacco op={true} />} />
            <Route path="/op/contrattualistica/distaccoestero" element={<ContrDistaccoEst op={true} />} />
            <Route path="/op/contrattualistica/praticagenerica" element={<ContrPraticheGeneriche op={true} />} />

            <Route path="/op/assunzioni" element={<OpPratiche titolo={'Assunzioni'} tipo={'assunzioni'} />} />
            <Route path="/op/cessazioni" element={<OpPratiche titolo={'Cessazioni'} tipo={'cessazioni'} />} />
            <Route path="/op/proroghe" element={<OpPratiche titolo={'Proroghe'} tipo={'proroghe'} />} />
            <Route path="/op/trasformazioni" element={<OpPratiche titolo={'Trasformazioni'} tipo={'trasformazioni'} />} />
            <Route path="/op/chiamateintermittenti" element={<OpPratiche titolo={'Chiamate Intermittenti'} tipo={'chiamateintermittenti'} />} />
            <Route path="/op/infortuni" element={<OpPratiche titolo={'Infortuni'} tipo={'infortuni'} />} />
            <Route path="/op/contestazioni" element={<OpPratiche titolo={'Contestazioni'} tipo={'contestazioni'} />} />
            <Route path="/op/distacchi" element={<OpPratiche titolo={'Distacchi'} tipo={'distacchi'} />} />
            <Route path="/op/distacchiesteri" element={<OpPratiche titolo={'Distacchi Esteri'} tipo={'distacchiesteri'} />} />
            <Route path="/op/pratichegeneriche" element={<OpPratiche titolo={'Pratiche Generiche'} tipo={'pratichegeneriche'} />} />
            <Route path="/op/annullamenti" element={<OpPratiche titolo={'Annullamenti'} tipo={'annullamenti'} />} />

            <Route path="/op/assunzioni/detail" element={<DetAssunzione />} />
            <Route path="/op/cessazioni/detail" element={<DetCessazione />} />
            <Route path="/op/proroghe/detail" element={<DetProroghe />} />
            <Route path="/op/malattie/detail" element={<DetMalattia />} />
            <Route path="/op/cassaintegrazioni/detail" element={<DetCassaIntegrazione />} />
            <Route path="/op/trasformazioni/detail" element={<DetTrasformazione />} />
            <Route path="/op/chiamateintermittenti/detail" element={<DetIntermittenti />} />
            <Route path="/op/infortuni/detail" element={<DetInfortunio />} />
            <Route path="/op/contestazioni/detail" element={<DetContestazioni />} />
            <Route path="/op/distacchi/detail" element={<DetDistacco />} />
            <Route path="/op/distacchiesteri/detail" element={<DetDistaccoEst />} />
            <Route path="/op/pratichegeneriche/detail" element={<DetPraticheGeneriche />} />
            <Route path="/op/annullamenti/detail" element={<DetAnnullamenti />} />

            <Route path="/op/amministrazione/listaaziende" element={<OpAmmListaAziende />} />
            <Route path="/op/amministrazione/avvisiparcella" element={<OpAmmAvvisiParcella />} />
            <Route path="/op/amministrazione/avvisiparcella/detail" element={<OpAmmAvvisiParcellaDet />} />
            <Route path="/op/amministrazione/fatture" element={<OpAmmFatture />} />
            <Route path="/op/amministrazione/pratichearchiviate" element={<OpAmmPraticheArchiviate />} />
            <Route path="/op/amministrazione/collaborazioni" element={<OpAmmCollaborazioni />} />

            <Route path="/op/paghe/presenze" element={<OpPagPresenze />} />
            <Route path="/op/paghe/dipendenti" element={<OpAmmDipendenti />} />
            <Route path="/op/paghe/timbrature" element={<AreaDipTimbrature op={true} />} />
            <Route path="/op/paghe/bustepaghe" element={<OpPagBustePaghe />} />
            <Route path="/op/paghe/paghefatte" element={<OpPagheFatte />} />
            <Route path="/op/paghe/malattia" element={<OpPratiche titolo={'Malattie'} tipo={'malattie'} />} />
            <Route path="/op/paghe/cassaintegrazione" element={<OpPratiche titolo={'Cassa Integrazione'} tipo={'cassaintegrazioni'} />} />
            <Route path="/op/paghe/archivio" element={<OpPagArchivio />} />

            <Route path="/op/enti/durc" element={<OpEntiArc />} />
            <Route path="/op/enti/edilconnect" element={<OpEntiEdilConnect />} />
            <Route path="/op/enti/edilconnect/detail" element={<OpEntiEdilConnectDet />} />
            <Route path="/op/enti/noterett" element={<OpEntiNoteRett />} />

            <Route path="/op/pannellocontrollo" element={<OpPannelloControllo />} />
            <Route path="/op/amministrazione/opoperazioni" element={<OpOperazioni />} />
            <Route path="/op/amministrazione/fatturato" element={<OpAmmFatturato />} />
            <Route path="/op/situazionegenerale" element={<OpSituazioneGenerale />} />
            <Route path="/op/contabilita" element={<OpContabilita />} />
            <Route path="/op/logs" element={<OpLogs />} />
            <Route path="/op/feedform" element={<FeedForm op={true} />} />
            <Route path="/op/notifiche" element={<OpNotifiche />} />
            <Route path="/op/news" element={<OpNews />} />

            <Route path="/op/dettaglioazienda" element={<DettaglioAzienda />} />

            <Route render={() => <div>Pagina non trovata</div>} />
          </Routes>
        </Box>
        {/* Render WhatsappButton only if the current path is "/" */}
        <WhatsappButtonWrapper />
        {/* Render Chat Sr Solo se Loggato */}
        <ChatButtonWrapper />
        {/* Render <Memo /> Sr Solo se Loggato */}
        <Memo />
        {/* Render <Ai /> Sr Solo se Loggato */}
        <Ai />
        <Footer />
      </Box>
    </Router>
  );
};

export default App;
